import React, { useEffect, useRef, useState } from "react";
import "./Header.scss";
import PrimaryButton from "../../common/primaryButton";
import { NavLink, useNavigate } from "react-router-dom";
import { blackLogo, whiteLogo } from "../../assets/images/images";
import { scrollToTop } from "../../common/ScrollToTop";

const Header = ({ dark, setOverlay, lightHeader }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMblDropdownOpen, setIsMblDropdownOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownMblRef = useRef(null);

  const navigate = useNavigate();
  const NavigateToMblContact = () => {
    navigate("/contact-us");
    setMenuOpen(!menuOpen);
    setShowMenu(!showMenu);
    if (!menuOpen) {
      setOverlay(true);
      document.body.classList.add("hide-scroll");
    } else {
      setOverlay(false);
      document.body.classList.remove("hide-scroll");
      scrollToTop();
    }
  };

  // add background color to navbar when scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // close menu
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
    setShowMenu(!showMenu);
    if (!menuOpen) {
      setOverlay(true);
      document.body.classList.add("hide-scroll");
    } else {
      setOverlay(false);
      document.body.classList.remove("hide-scroll");
      scrollToTop();
    }
  };

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  // for mobile
  const toggleMblDropdown = () => {
    setIsMblDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // for mobile
  useEffect(() => {
    const handleMblClickOutside = (event) => {
      if (
        dropdownMblRef.current &&
        !dropdownMblRef.current.contains(event.target)
      ) {
        setIsMblDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleMblClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleMblClickOutside);
    };
  }, []);

  return (
    <>
      <header className={`${scrolling ? "scroll-color" : ""}`}>
        <div className={`container ${lightHeader ? "light-header" : ""}`}>
          <div className="logo">
            <NavLink to="/">
              <img
                src={
                  lightHeader ? (scrolling ? whiteLogo : blackLogo) : whiteLogo
                }
                alt="logo"
              />
            </NavLink>
          </div>
          <div
            className={`hamburger-icon ${showMenu ? "animate" : ""}`}
            onClick={handleMenuClick}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          {/* web menu */}
          <ul className="web-nav-menu">
            <li>
              <NavLink to="/about-us">About us</NavLink>
            </li>
            <li>
              <NavLink to="/our-technology">Our Technology</NavLink>
            </li>
            <li>
              <NavLink to="/genetic-counseling">Genetics Counseling</NavLink>
            </li>
            <li>
              <NavLink to="/blogs">Blog</NavLink>
            </li>
            <li>
              <NavLink to="/faq">Resources</NavLink>
            </li>
            <li>
              <PrimaryButton
                primaryBtnText="Get Started"
                className={`${scrolling ? "secondary" : ""}`}
                primaryExternalLink={"https://portal.gattacagenomics.com/"}
              />
            </li>
          </ul>

          {/* mobile menu */}
          <div className={`mbl-menu ${menuOpen ? "toggle-menu" : ""}`}>
            <div className="mbl-nav-items">
              <div className="logo">
                <NavLink to="/">
                  <img src={dark ? blackLogo : whiteLogo} alt="logo" />
                </NavLink>
              </div>
              <ul>
                <li onClick={handleMenuClick}>
                  <NavLink to="/about-us">About us</NavLink>
                </li>
                <li onClick={handleMenuClick}>
                  <NavLink to="/our-technology">Our Technology</NavLink>
                </li>
                <li onClick={handleMenuClick}>
                  <NavLink to="/genetic-counseling">
                    Genetics Counseling
                  </NavLink>
                </li>
                <li onClick={handleMenuClick}>
                  <NavLink to="/blogs">Blog</NavLink>
                </li>
                <li onClick={handleMenuClick}>
                  <NavLink to="/faq">Resources</NavLink>
                </li>
                <li>
                  <PrimaryButton
                    primaryBtnText="Get Started"
                    primaryExternalLink={"https://portal.gattacagenomics.com/"}
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
